import { FC, SVGProps } from "react";

const Close: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M21.6529 19L36.5779 4.07505C37.3104 3.34255 37.3104 2.15504 36.5779 1.42254C35.8454 0.690044 34.6579 0.690044 33.9254 1.42254L19.0004 16.3475L4.07541 1.42504C3.34291 0.692544 2.15541 0.692544 1.42291 1.42504C0.69041 2.15754 0.69041 3.34504 1.42291 4.07755L16.3479 19.0025L1.42291 33.9276C0.69041 34.66 0.69041 35.8475 1.42291 36.58C1.78791 36.945 2.26791 37.1301 2.74791 37.1301C3.22791 37.1301 3.70791 36.9475 4.07291 36.58L18.9979 21.655L33.9229 36.58C34.2879 36.945 34.7679 37.1301 35.2479 37.1301C35.7279 37.1301 36.2079 36.9475 36.5729 36.58C37.3054 35.8475 37.3054 34.66 36.5729 33.9276L21.6529 19Z"
        fill="white"
      />
    </svg>
  );
};

export default Close;
